import GlobalJewelryCategoryComp from "../GlobalJewelryCategoryComp";
import GlobalJewelryMetalTypeComp from "../GlobalJewelryMetalTypeComp";
import GlobalJewelryPriceComp from "../GlobalJewelryPriceComp";
import { GLOBAL_REPORT_FLAGS } from "../../_shared/globalReportSettings";
import { isValidMetalType } from "../../jewelry/_shared/isValidMetalType";

// Global mirrors the Dealer configs (jewelry/_shared/jewelryReportConfigs.js)
// but points at the Admin-stack chart endpoints, whose typed responses use
// different field casing (camelCase: "category"/"count", "range"/"total",
// "metalType"/"count"/"metalTypeID"/"metalColorID") than the Dealer stack's
// raw-DataTable passthrough. detail.filterParamName/fileNamePart line up
// with JewelryDetailSearchTable, same as Dealer.
export const GLOBAL_CATEGORY_CONFIG = {
  key: "globalCategory",
  dataKey: "JewelryCategorySearches",
  labelField: "category",
  valueField: "count",
  dimensionLabel: "Category",
  pageTitle: "Jewelry Category Report",
  ChartCard: GlobalJewelryCategoryComp,
  noiseFilter: null,
  hideTotalDimensionSum: true,
  showTop3Concentration: true,
  // Task 2344 / 2345: percent-only + same-dates-last-year (globalReportSettings.js).
  ...GLOBAL_REPORT_FLAGS,
  totalClicksKey: "JewelryTotalClicks",
  summaryKpiKey: "JewelrySummaryKPIs",
  detail: { filterParamName: "category", fileNamePart: "GlobalJewelryCategoryReports" },
};

export const GLOBAL_METAL_TYPE_CONFIG = {
  key: "globalMetalType",
  // Percent-only Total Clicks = this attribute's clicks / all jewelry clicks (Task 2344).
  totalShareKey: "JewelryAllClicks",
  totalShareLabel: "of all jewelry clicks",
  dataKey: "JewelryMetalTypeSearches",
  labelField: "metalType",
  valueField: "count",
  dimensionLabel: "Metal Type",
  pageTitle: "Jewelry Metal Type Report",
  ChartCard: GlobalJewelryMetalTypeComp,
  noiseFilter: { isValid: isValidMetalType, toggleLabel: "Hide None / unspecified" },
  // Percent-only: no "Flagged / Grouped" card - AdminJewelryMetaltypeChartColunm
  // already drops None / N/A, so it could only read 0%; its "Other" row is the
  // metal types beyond the top 10 (QA 2344).
  hideFlagged: GLOBAL_REPORT_FLAGS.percentOnly,
  hideTotalDimensionSum: true,
  showTop3Concentration: true,
  // Task 2344 / 2345: percent-only + same-dates-last-year (globalReportSettings.js).
  ...GLOBAL_REPORT_FLAGS,
  totalClicksKey: "JewelryTotalClicks",
  summaryKpiKey: "JewelrySummaryKPIs",
  detail: { filterParamName: "metalType", fileNamePart: "GlobalJewelryMetalTypeReports" },
};

export const GLOBAL_PRICE_CONFIG = {
  key: "globalPrice",
  // Percent-only Total Clicks = this attribute's clicks / all jewelry clicks (Task 2344).
  totalShareKey: "JewelryAllClicks",
  totalShareLabel: "of all jewelry clicks",
  dataKey: "JewelryPriceSearches",
  labelField: "range",
  valueField: "total",
  dimensionLabel: "Price Band",
  pageTitle: "Jewelry Price Report",
  ChartCard: GlobalJewelryPriceComp,
  noiseFilter: null,
  hideTotalDimensionSum: true,
  showTop3Concentration: true,
  // Task 2344 / 2345: percent-only + same-dates-last-year (globalReportSettings.js).
  ...GLOBAL_REPORT_FLAGS,
  totalClicksKey: "JewelryTotalClicks",
  summaryKpiKey: "JewelrySummaryKPIs",
  detail: { filterParamName: "price", fileNamePart: "GlobalJewelryPriceReports" },
};
